export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import type {XMarkdownFormulaDelimiter} from 'kpc';
import {bind} from 'kpc';

interface Props {
    enableFormula: boolean
    useBrackets: boolean
}

const DOLLARS_CONTENT = `欧拉恒等式：$e^{i\\pi} + 1 = 0$。

定义域：$f: \\RR \\to \\RR$。

$$
\\score(x)=\\sum_{i=1}^{n}\\frac{x_i}{1 + x_i^2}
$$

\\begin{equation}
\\int_0^1 x^2 dx = \\frac{1}{3}
\\end{equation}
`;

const BRACKETS_CONTENT = `下面这段内容改用 \\[ ... \\] 分隔符：

\\[
f: \\RR \\to \\RR
\\]

\\[
\\score(x)=\\sum_{i=1}^{n}\\frac{x_i}{1 + x_i^2}
\\]`;

export default class extends Component<Props> {
    static template = template;

    static defaults() {
        return {
            enableFormula: true,
            useBrackets: false,
        };
    }

    getContent() {
        return this.get('useBrackets') ? BRACKETS_CONTENT : DOLLARS_CONTENT;
    }

    getFormulaDelimiters(): XMarkdownFormulaDelimiter | XMarkdownFormulaDelimiter[] {
        return this.get('useBrackets') ? 'brackets' : ['dollars', 'beg_end'];
    }

    getFormulaMacros() {
        return {
            '\\RR': '\\mathbb{R}',
            '\\score': '\\operatorname{score}',
        };
    }

    @bind
    setEnableFormula(enableFormula?: boolean) {
        this.set('enableFormula', !!enableFormula);
    }

    @bind
    setUseBrackets(useBrackets?: boolean) {
        this.set('useBrackets', !!useBrackets);
    }
}